import { RootState } from '../store';
import { createAsyncThunk } from '@reduxjs/toolkit';
import apiVRR, { ApiVRR } from '../../libs/axios/apis';
import endPoints from '../../services/endpoints';
import { notify } from '../app/appSlice';
import {
  TInsightsInitialState,
  TOverviewInitialState,
  TParams,
  TSettingInitialState,
  TVrrPreferencesInitialState
} from './types';
import { TBrandLabel } from '../userProfile/types';

export const fetchVrrSettings = createAsyncThunk(
  'setting/fetchVrrSettings',
  async () => {
    const endpointURL = `/users/tokens/info`;
    const response = await new ApiVRR('').createHttpClient().get(endpointURL);

    return response.data;
  }
);

export const fetchOverviewSettings = createAsyncThunk(
  'setting/fetchSettings',
  async (__, { getState }) => {
    const currentState = getState() as any;
    const currentBrandId =
      currentState.setting.vrr_preferences.current_brand_id;
    return await apiVRR('v2').get(endPoints.APP.SETTINGS, {
      params: {
        brand_id: currentBrandId,
        page: 'overview'
      }
    });
  }
);

export const fetchInsightSettings = createAsyncThunk(
  'setting/fetchInsightSettings',
  async (__, { getState }) => {
    const currentState = getState() as any;
    const currentBrandId =
      currentState.setting.vrr_preferences.current_brand_id;
    return await apiVRR('v2').get(endPoints.APP.SETTINGS, {
      params: {
        brand_id: currentBrandId,
        page: 'insights'
      }
    });
  }
);

export const updateVrrSettings = createAsyncThunk(
  'setting/updateVrrSettings',
  async ({ resource_id, value, notification }: TParams, { dispatch }) => {
    const response = await apiVRR('v2').patch(endPoints.APP.SETTINGS, {
      resource_id,
      settings: value
    });

    if (response.status >= 200 && response.status < 400 && notification) {
      dispatch(notify({ type: 'success' }));
    }

    return response;
  }
);

export const updateOverviewSettings = createAsyncThunk(
  'setting/updateOverviewSettings',
  async ({ resource_id, value, notification }: TParams, { dispatch }) => {
    const response = await apiVRR('v2').patch(endPoints.APP.SETTINGS, {
      resource_id,
      settings: value
    });

    if (response.status >= 200 && response.status < 400 && notification) {
      dispatch(notify({ type: 'success' }));
    }

    return response;
  }
);

export const updateInsightsSettings = createAsyncThunk(
  'setting/updateInsightsSettings',
  async ({ resource_id, value }: TParams) => {
    return await apiVRR('v2').patch(endPoints.APP.SETTINGS, {
      resource_id,
      settings: value
    });
  }
);

export const getVrrPreferences = (
  state: RootState
): TSettingInitialState['vrr_preferences'] | undefined =>
  state.setting.vrr_preferences;

export const getCustomLabelsPreferences = (
  state: RootState
): TVrrPreferencesInitialState['custom_labels'] | undefined =>
  state.setting.vrr_preferences?.custom_labels;

export const getCurrentCustomLabelsPreferences = (
  state: RootState
): TBrandLabel[] | null => {
  const currentBrand = state.setting.vrr_preferences?.current_brand_id;
  if (currentBrand) {
    const customLabels = state.setting.vrr_preferences?.custom_labels;
    const currentCustomLabels = customLabels?.find(
      (node) => node[Number(currentBrand)] !== undefined
    );
    return currentCustomLabels?.[Number(currentBrand)] ?? null;
  }
  return null;
};

export const getOverviewPreferences = (
  state: RootState
): TOverviewInitialState | undefined => state.setting.overview;

export const getInsightsPreferences = (
  state: RootState
): TInsightsInitialState | undefined => state.setting.insights;

export const getOverviewDMPreferences = (
  state: RootState
): TOverviewInitialState['detailed_metrics'] | undefined =>
  state.setting.overview?.detailed_metrics;

export const getOverviewGMPreferences = (
  state: RootState
): TOverviewInitialState['global_metrics'] | undefined =>
  state.setting.overview?.global_metrics;
